import React from "react";
import { useState } from "react";
import { ISelectOption } from "../forms/util";
import { ReactComponent as TakeFiveIcon } from "assets/icons/take-five.svg";
import './TakeFive.css'
import { takeFiveHomePage, takeFive, takeFiveOverview } from "./TakeFivePageSelector";
import { Link } from "react-router-dom";

import {
    ChevronRight as RightIcon} from '@mui/icons-material';

interface TakeFiveSidebarProps {
    selectedPage: ISelectOption
}

export const TakeFiveSidebar = (props: TakeFiveSidebarProps) => {
    const [currentSelection, setCurrentSelection] = useState(props.selectedPage);

    return (
        <>
            <div className="tf-sidebar tf-sidebar-nav">
                <div className="tf-sidebar-title">
                    <TakeFiveIcon />
                    <div className="d-inline-block">Digital Take 5</div>
                </div>

                <div className="tf-sidebar-item">
                    <Link
                        to={takeFiveHomePage.getRoute().path as string}
                        className={`${currentSelection == takeFiveHomePage ? 'tf-nav-selected' : ''}`}>
                        <div className="row">
                            <div className="col-11">{takeFiveHomePage.label}</div>
                            <div className="col-1"><RightIcon /></div>
                        </div>
                    </Link>
                </div>

                <div className="tf-sidebar-item tf-sidebar-subitem">
                    <Link
                        to={takeFiveOverview.getRoute().path as string}
                        className={`${currentSelection == takeFiveOverview ? 'tf-nav-selected ' : ''}tf-nav-subitem`}>
                        <div className="row">
                            <div className="col-11">{takeFiveOverview.label}</div>
                            <div className="col-1"><RightIcon /></div>
                        </div>
                    </Link>
                </div>

                <div className="tf-sidebar-item tf-sidebar-subitem">
                    <Link
                        to={takeFive.getRoute().path as string}
                        className={`${currentSelection == takeFive ? 'tf-nav-selected ' : ''}tf-nav-subitem`}>
                        <div className="row">
                            <div className="col-11">{takeFive.label}</div>
                            <div className="col-1"><RightIcon /></div>
                        </div>
                    </Link>
                </div>
            </div>
        </>
    );
};